module.exports = __webpack_public_path__ + "img/feather-pointed-duotone.481410d6.svg";